module.exports = __webpack_public_path__ + "static/media/correct-outlined.a4ef1875.svg";